<script setup lang="ts">
import { storeToRefs } from "pinia"
import { ALButton, ALModal } from "@af-lib/vue-ui"
import { useLeaveWindowModalStore } from "./leaveWindowModal.store"
import { useI18nStore } from "@/stores/i18n"

const { currentLocale } = storeToRefs(useI18nStore())
const { isActive } = storeToRefs(useLeaveWindowModalStore())
</script>

<template>
  <ALModal
    v-model="isActive"
    size="l"
    variant="default"
    headerIcon="fa-thin fa-person-running-fast"
    :class="currentLocale.iso_code_639 === 'ar-SA' && 'arabic'"
  >
    <template #header>
      <span class="text-af-grey-800 font-bold">
        {{ $t("voice.assessment.cheat_warning.title") }}
      </span>
    </template>

    <template #content>
      <p class="text-af-grey-800 text-base font-light">
        {{ $t("voice.assessment.cheat_warning.body") }}
      </p>
    </template>

    <template #footer>
      <ALButton
        class="w-full md:w-auto"
        :label="$t('general.understood')"
        @click="isActive = false"
      />
    </template>
  </ALModal>
</template>
